import React, { useState } from 'react';
import axios from 'axios';

function JoinProject() {
    const [code, setCode] = useState('');
    const [status, setStatus] = useState({ type: '', msg: '' });

    const handleJoin = async (e) => {
        e.preventDefault();
        setStatus({ type: '', msg: '' });

        try {
            const token = localStorage.getItem('token'); // Matches your Login.js logic
            const response = await axios.post('http://localhost:5000/api/projects/join', 
                { projectCode: code },
                { headers: { Authorization: `Bearer ${token}` } } // Sends token to middleware
            );

            setStatus({ type: 'success', msg: response.data.message });
            setCode('');
        } catch (err) {
            setStatus({ 
                type: 'error', 
                msg: err.response?.data?.error || "Error joining project" 
            });
        }
    };

    return (
        <div className="join-project-container">
        <div className="glass-panel join-card">
            <div className="create-project-header">
                <h2>Join Project</h2>
                <p>Enter the 6-character code to join a team.</p>
            </div>
            
            <form onSubmit={handleJoin} className="join-form">
                <div className="form-group">
                    <label>Invite Code</label>
                    <input 
                        type="text" 
                        className="join-input"
                        value={code}
                        placeholder="XOX5AI"
                        onChange={(e) => setCode(e.target.value.toUpperCase())}
                        required
                        maxLength="10"
                    />
                </div>
                
                <button type="submit" className="project-submit-btn">
                    Join Team
                </button>
            </form>

            {status.msg && (
                <div className={`status-message ${status.type}`}>
                    {status.msg}
                </div>
            )}
        </div>
    </div>
    );
}

export default JoinProject;